export const environment = {
  production: false,
  apiBaseUrl: 'https://api.pmconline-nonprod.global',
  aiApiUrl: 'https://ai.pmconline-nonprod.global',
  apiKey: 'AIzaSyAnygpGBMdK-cotBvzP9jFrsc1mUasDfkQ',
};
